// extracted by mini-css-extract-plugin
export default {"-large":"zfh8m1pL9f_38VWGquD9","popup":"RBFUJ51lXj_IlB17DjYM","list":"NWxVKKbOUMorLUm0kU6g","item":"Exwyj8NGQQKFGnsHvfBw","mergeTagOptionText":"_AQhJ5KQR46QlG7ATNQz"};